import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

export const FAQAccordion = ({
  faqs,
  sectionLabel = 'Common Questions',
  title = 'Frequently Asked Questions',
}) => {
  const [expanded, setExpanded] = useState(null);
  const toggle = (i) => setExpanded(expanded === i ? null : i);

  return (
    <section className="py-20 md:py-32 bg-[#F1F5F8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-medium uppercase tracking-widest text-[#163A59] mb-4">
            {sectionLabel}
          </p>
          <h2 className="font-['Source_Serif_4'] text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900 mb-6">
            {title}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={faq.question}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-white border border-slate-200"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-[#F1F5F8] transition-colors"
                data-testid={`faq-toggle-${index}`}
              >
                <div className="flex items-center gap-3">
                  <HelpCircle className="w-5 h-5 text-[#163A59] flex-shrink-0" />
                  <span className="font-medium text-slate-900">{faq.question}</span>
                </div>
                {expanded === index ? (
                  <ChevronUp className="w-5 h-5 text-slate-400 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-slate-400 flex-shrink-0" />
                )}
              </button>

              <AnimatePresence>
                {expanded === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-4 pt-0 border-t border-slate-200">
                      <p className="text-slate-600 pl-8">{faq.answer}</p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
